/**
 * This component renders the "Next game" and "Current Leaders" sections for a division page
 */
import React from "react";
import {formatEpochToLongDateAndTime as formatDate, formatFaceoffTimeDate} from "../utils/time";

const DivisionInfo = ({
                          leader,
                          leaderimg,
                          leader_record,
                          team1,
                          team2,
                          team1img,
                          team2img,
                          epocdate,
                          date,
                          time,
                          location,
                          title,
                      }) => {
    return (
        <div className="flex w-full mb-4 flex-col xs:flex-row items-start justify-between pt-2 md:pt-4">
            {/* Leader*/}
            {(leader !== undefined) ? (
                <div
                    className="w-full flex flex-col w-full border-2 dark:border-0 border-light-3 dark:bg-dark-4 rounded p-2 xs:mr-2 h-24 xs:h-28 items-center justify-center max-xs:mb-2">
                    <p className="leading-tight text-center text-lg md:text-xl font-bold mb-2">
                        Current Leaders
                    </p>
                    <div className="flex flex-row items-center justify-center">
                        <img
                            src={leaderimg}
                            alt={leader}
                            className="xs:max-sm:mr-2 mr-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                        />
                        <p className="text-sm md:text-xl text-center">
                            {leader} ({leader_record})
                        </p>
                    </div>
                </div>
            ) : null}

            {/* Next game*/}
            <div
                className="w-full flex flex-col w-full border-2 dark:border-0 border-light-3 dark:bg-dark-4 rounded p-2 xs:ml-2 h-24 xs:h-28 items-center justify-center">
                <p className="leading-tight text-center text-lg md:text-xl font-bold mb-1 sm:mb-2">
                    Next Game
                </p>
                <div className="flex flex-row items-center justify-center">
                    <img
                        src={team1img}
                        alt={team1}
                        className="mr-4 xs:max-sm:mr-2 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                    <div className="flex flex-col items-center justify-center mx-2">
                        {title !== undefined ? (<p className="leading-tight text-center text-md md:text-lg font-bold">{title}</p>) : null}
                        <p className="text-sm md:text-xl leading-tight pb-1 text-center">
                            {team1} vs {team2}
                        </p>
                        <p className="leading-tight text-center text-xxs">
                            {location}, {(date !== undefined && time !== undefined) ? <>{date} {time}</> : formatFaceoffTimeDate(epocdate)}
                        </p>
                    </div>
                    <img
                        src={team2img}
                        alt={team2}
                        className="ml-4 xs:max-sm:ml-2 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                </div>
            </div>
        </div>
    );
};

export default DivisionInfo;
